import { addEvent } from './eventBus';
const MOBILE_BREAKPOINT = 768;

const getwindowInnerWidth = (): number => {
  return document.body && document.body.clientWidth ? document.body.clientWidth : window.innerWidth;
}

const getIframeWidthFromRatio = (videoWidthRatio: number): number => {
  const windowInnerWidth = getwindowInnerWidth();
  return windowInnerWidth > MOBILE_BREAKPOINT ? (windowInnerWidth * videoWidthRatio) : windowInnerWidth;
}


const onYoutubeIframeAPIReadyCallback = (): void => {
  
  console.info('init Youtube iframes'); // eslint-disable-line no-console
  const YT = window['YT'];
  const players = document.querySelectorAll('[data-yt-player]');

  players.forEach(playerEl => {
    const playerUrl = playerEl.getAttribute('data-video-url');
    
    // Client has added videos in "youtu.be/XXXX" format, so grabbing the id here
    const playerId = playerUrl.split('/').pop();
    let player; // eslint-disable-line prefer-const

    const onPlayerStateChange = (e: any) => {
      if (player && e.data === YT.PlayerState.ENDED) {
        player.seekTo(0);
      }
    };
    const onPlayerReady = () => {
      if (player) {
        player.unMute();
      }
    };
    
    const videoWidthRatio = parseFloat(playerEl.getAttribute('data-width-ratio'));
    const iframeWidth = getIframeWidthFromRatio(videoWidthRatio);
    const iframeHeight = iframeWidth * 0.56; // 0.56 is the calc to turn the width to height based on an aspect ratio of 16:9 - yt default
    
    player = new YT.Player(playerEl.id, {
      height: iframeHeight,
      width: iframeWidth,
      videoId: playerId,
      playerVars: {
        modestbranding: 1,
        autoplay: 0,
        controls: 1,
        showinfo: 0,
        branding: 0,
        rel: 0,
        autohide: 0
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });
    
    addEvent('modalopen', () => {
      player.unMute();
      player.playVideo();
    });
    addEvent('modalclose', () => player.pauseVideo());
  })
}

const initYoutubeVideo = (): void => {
  const players = document.querySelectorAll('[data-yt-player]');
  if (!players.length) return;

  // Add the script to the page
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  // Listen to API ready event
  window['onYouTubeIframeAPIReady'] = function () {
    window['onYouTubeIframeAPIReady'] = null;
    onYoutubeIframeAPIReadyCallback();
  };
}

/**
 * PDP specific video instantiation
 */
const initPDPYoutubeVideo = (): void => {
  const playerEl: HTMLDivElement = document.querySelector('[data-pdp-yt-player]');
  if (!playerEl) return;

  // Add the script to the page
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  // Listen to API ready event
  window['onYouTubeIframeAPIReady'] = function () {
    window['onYouTubeIframeAPIReady'] = null;

    console.info('init PDP Youtube iframe'); // eslint-disable-line no-console
    const YT = window['YT'];
    const playerId = playerEl.getAttribute('data-video-id');
    let player; // eslint-disable-line prefer-const

    const onPlayerStateChange = (e: any) => {
      if (player) {
        if (e.data === YT.PlayerState.ENDED || e.data === YT.PlayerState.PAUSED) {
          document.querySelector('[data-pdp-yt-video-container]').classList.add('paused');
          document.querySelector('[data-pdp-yt-video-container]').classList.remove('loading');
        } else if (e.data === YT.PlayerState.BUFFERING) {
          document.querySelector('[data-pdp-yt-video-container]').classList.add('loading');
        } else if (e.data === YT.PlayerState.PLAYING) {
          document.querySelector('[data-pdp-yt-video-container]').classList.remove('loading');
          document.querySelector('[data-pdp-yt-video-container]').classList.remove('paused');
        }
      }
    };

    player = new YT.Player(playerEl.id, {
      height: '390',
      width: '640',
      videoId: playerId,
      playerVars: {
        modestbranding: 1,
        autoplay: 0,
        controls: 0,
        showinfo: 0,
        branding: 0,
        rel: 0,
        autohide: 0,
        mute: 0,
      },
      events: {
        'onStateChange': onPlayerStateChange
      }
    });

    // Handle Play button click
    const playBtn = document.querySelector('[data-yt-play-btn]');
    playBtn.addEventListener('click', () => {
      player.playVideo();
    });
  };
}

export {
  initYoutubeVideo,
  initPDPYoutubeVideo
}
